import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { Query } from '@apollo/client/react/components';
import Styled from 'styled';

import query, { FriendsLastVisitCountQuery } from 'four-nets/photoblog/latest-albums/friends-last-visit-count.graphql';

import defaultStyles from './feed-filter.scss';

interface Props {
    styles: typeof defaultStyles;
}

class FeedFilter extends React.Component<Props> {
    render() {
        const styles = this.props.styles!;

        return (
            <div className={styles.container}>
                <NavLink to='/blogs/' exact className={styles.button} activeClassName={styles.active}>
                    <FormattedMessage id='PHOTOBLOGS_ALL' />
                </NavLink>
                <NavLink to='/blogs/my-selection/' exact className={styles.button} activeClassName={styles.active}>
                    <FormattedMessage id='MY_SELECTION' />
                </NavLink>

                <NavLink to='/blogs/friends/' className={styles.button} activeClassName={styles.active}>
                    <FormattedMessage id='PB_MENU_FRIENDS_AND_FAVORITES' />
                    <Query<FriendsLastVisitCountQuery> query={query} fetchPolicy='cache-first'>
                        {({ data }) =>
                            data && data.friendsLastVisitCount ? (
                                <span className={styles.highlight}>({data.friendsLastVisitCount})</span>
                            ) : null
                        }
                    </Query>
                </NavLink>
            </div>
        );
    }
}

export default Styled(defaultStyles)(FeedFilter);
